import { useEffect } from 'react';
import {initAOS} from "../../Helpers";
import $ from 'jquery';

export default function scripts() {

    useEffect(() => {

        $('.main-menu li').mouseenter(function (){
            $(this).removeClass('active');
            $(this).siblings().addClass('active');
        });

        $('.main-menu').mouseleave(function (){
            $('.main-menu li').removeClass('active');
        });

        $('.list-wrap li').mouseenter(function (){
            $(this).removeClass('active');
            $(this).siblings().addClass('active');
        });

        $('.list-wrap').mouseleave(function (){
            $('.list-wrap li').removeClass('active');
        });

        /*-------------------------------------------
            Sticky Header
        --------------------------------------------- */

        // let win = $(window);
        // let sticky_id = $(".header-area");
        // win.on('scroll', function () {
        //     let scroll = win.scrollTop();
        //     if (scroll < 245) {
        //         sticky_id.removeClass("sticky-header");
        //     } else {
        //         sticky_id.addClass("sticky-header");
        //     }
        // });

        // $(window).on('scroll', function () {
        //     let scroll = $(window).scrollTop();
        //     if (scroll < 300) {
        //         $('.s-service-content .scroll-down,.pro-scroll-down,.e-hero-area .scroll-down').css('opacity', 1);
        //     } else {
        //         $('.s-service-content .scroll-down,.pro-scroll-down,.e-hero-area .scroll-down').css('opacity', 0);
        //     }
        // });


        $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            var documentHeight = $(document).height();
            var windowHeight = $(window).height();
            var scrollPercent = (scrollTop / (documentHeight - windowHeight)) * 100;
            var factor = 28;
            var newSize = 100 + (scrollTop / factor) + '%';

            $('.hero-area').css({
                'transform': 'scale('+newSize+')'
            });
            $('.s-service-content .scroll-down, .pro-scroll-down, .e-hero-area .scroll-down, .hero-area .scroll-down').css({
                'opacity': + 1-(scrollPercent/8)
            });
            $('.hero-area .shape').css({
                'transform': 'translateY(-50%) rotate(' + scrollPercent * 3.6 + 'deg)'
            });
        });

        $('.hero-area .scroll-down').on('click', function() {
            $(window).scrollTop($('.hero-area').height());
        });

        /*------------------------------------
            Data-Background
        --------------------------------------*/
        $("[data-background]").each(function () {
            $(this).css("background-image", "url(" + $(this).attr("data-background") + ")")
        });

        $("[data-bg-color]").each(function () {
            $(this).css("background", $(this).attr("data-bg-color"))
        });

        if ($(".popup-video").length > 0) {
            // new VenoBox({
            //     selector: '.popup-video',
            //     numeration: true,
            //     infinigall: true,
            //     share: true,
            //     spinner: 'rotating-plane'
            // });
        }

        initAOS();
    }, []);

    return null;
}
